import type { TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './tweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
